import { NavLink } from 'react-router-dom';

// iOS-style bottom tab bar. tabs: [{ to, label, Icon, badge }]
export default function BottomTabBar({ tabs }) {
  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 bg-white border-t border-gray-200 pb-[env(safe-area-inset-bottom)]">
      <div className="flex max-w-lg lg:max-w-none mx-auto">
        {tabs.map(({ to, label, Icon, badge }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              `relative flex-1 flex flex-col items-center gap-0.5 py-1.5 pt-2 text-[10px] font-medium transition-colors ${
                isActive ? 'text-[#FF3B30]' : 'text-[#8E8E93]'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span className="relative">
                  <Icon size={22} strokeWidth={isActive ? 2.4 : 1.8} />
                  {badge > 0 && (
                    <span className="absolute -top-1.5 -right-2 min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[9px] font-bold flex items-center justify-center">
                      {badge > 99 ? '99+' : badge}
                    </span>
                  )}
                </span>
                {label}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
